import { DatePipe, LowerCasePipe, TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { AgentCardDto, FrenchDepartment } from '@workspace/data-types';
import { BaseDataTableCoreComponent, DataTableComponent } from '@workspace/ng-aura';
import { AgentCardColumnKey } from './abstract-agent-cards-data-table.component';
import { AgentCardsDataTableFilterComponent } from './filter/agent-cards-data-table-filter.component';

@Component({
  selector: 'etxe-agent-cards-data-table',
  templateUrl: './agent-cards-data-table.shared.component.html',
  imports: [
    DataTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatButtonModule,
    MatCellDef,
    MatCell,
    DatePipe,
    MatIconModule,
    MatTooltipModule,
    RouterModule,
    TitleCasePipe,
    LowerCasePipe,
    AgentCardsDataTableFilterComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentCardsDataTableComponent extends BaseDataTableCoreComponent<
  AgentCardDto,
  AgentCardColumnKey
> {
  getDepartmentName(code: string | undefined): string {
    if (!code) return '-';
    const key = Object.keys(FrenchDepartment).find(
      (k) => FrenchDepartment[k as keyof typeof FrenchDepartment] === code,
    );
    if (!key) return code;
    return key
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  isCardExpired(expiresAt: string | Date | undefined): boolean {
    if (!expiresAt) return false;
    const expDate = new Date(expiresAt);
    return expDate.getTime() < Date.now();
  }
}
